import React from 'react';
import ModuleError from 'app/components/districtModulesCommon/ModuleError';
export default function MediaModuleError(_ref) {
  let {
    onRetry
  } = _ref;
  return /*#__PURE__*/React.createElement(ModuleError, {
    onClick: onRetry,
    text: "Es ist ein Fehler aufgetreten und die aktuellen Fotos und Video-Highlights konnten leider nicht geladen werden. Bitte versuche es erneut.",
    "data-sentry-element": "ModuleError",
    "data-sentry-component": "MediaModuleError",
    "data-sentry-source-file": "MediaModuleError.tsx"
  });
}